import { createApp } from "vue";
import BranchSelectorMenu from "../vue/components/BranchSelectorMenu.vue";
import { i18n } from '../i18n';

const branchMenu = Object.freeze({
  component: "#branch-selector-component",
  button: "#company-dropdown"
})

export function mountBranchSelectorComponent(props) {
  const app = createApp(BranchSelectorMenu, {
    activeBranchId: props.activeBranchId,
    preferredBranchId: props.preferredBranchId,
    userId: props.userId,
    isGroupLevelDashboard: props.isGroupLevelDashboard,
    isGroupOwner: props.isGroupOwner,
    page: props.page,
    initialAreas: props.initialAreas || null,
    hasPro: props.groupPermissions ? props.groupPermissions.hasPro : false,
    hasTrial: props.groupPermissions ? props.groupPermissions.hasTrial : false,
  })
  app.use(i18n);
  window[branchMenu.component] = app.mount(branchMenu.component);
  window[branchMenu.component].initData(props.employments);
  addClickEventOnBranchMenu();
  closeBranchListOnClick();
}

function addClickEventOnBranchMenu() {
  $(branchMenu.button).on("click", () => {
    window[branchMenu.component].showBranchList()
  })
}

function closeBranchListOnClick() {
  $("#app").on("click", () => {
    window[branchMenu.component].closeBranchList()
  })
}

export function updateBranchListComponent(newEmploymentOrder) {
  window[branchMenu.component].updateBranchPos(newEmploymentOrder)
}
